<script lang="ts">
	import type { Collection, Element } from 'src/utils/types';
	import { canRender } from '../../../utils/renderBorder';
	import { LightenDarkenColor } from '../../../utils/colors';
	import { CIRCLE_DIAMETER } from '../../../utils/constants';

	export let collection: Collection;
	export let element: Element;

	const { left, right, top, bottom } = canRender(collection, element);
</script>

<div class="socketx">
	{#if !left}
		<div
			class="socket"
			style="left:{-CIRCLE_DIAMETER / 2}px; top :{25 - 3}px; background-color:{LightenDarkenColor(
				element.color,
				60
			)}"
		/>
	{/if}
	{#if !right}
		<div
			class="socket"
			style="left:{25 + CIRCLE_DIAMETER / 2}px;top :{25 - 3}px;background-color:{LightenDarkenColor(
				element.color,
				60
			)}"
		/>
	{/if}
	{#if !top}
		<div
			class="socket"
			style="left:{25 - 3}px;top:-{CIRCLE_DIAMETER /
				2}px;width:5px;height:25px;background-color:{LightenDarkenColor(element.color, 60)}"
		/>
	{/if}
	{#if !bottom}
		<div
			class="socket"
			style="left:{25 - 3}px;top:{25 +
				CIRCLE_DIAMETER / 2}px;width:5px;height:25px;background-color:{LightenDarkenColor(
				element.color,
				60
			)}"
		/>
	{/if}
</div>

<style>
	.socketx {
		position: relative;
		width: 100%;
		height: 100%;
		z-index: 90;
	}
	.socket {
		position: absolute;
		width: 25px;
		height: 6px;
		top: 25px;
		left: 0px;
		background-color: red;
	}
</style>
